import { Button } from "@material-ui/core";
import { makeStyles } from "@material-ui/styles";
import React from "react";

const useStyles = makeStyles(theme => ({
	root: {},
	danger: {
		backgroundColor: theme.palette.danger.main
	}
}));

export default function ColorButton({ type, children, ...rest }) {
	const classes = useStyles();
	return (
		<Button className={type === "danger" ? classes.danger : ""} {...rest}>
			{children}
		</Button>
	);
}
